<template>
  <div></div>
</template>

<script>
window.top.postMessage('user-leave', '*')
</script>
